import { useState } from "react";
import { FolderOpen, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, errorMessage } from "../../lib/api";

// REQ-368: paste a public folder link; the server answers with the name and an opaque token (REQ-361).
export const DriveLinkDialog = ({ open, onClose, onPick }) => {
  const [link, setLink] = useState("");
  const [found, setFound] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const close = () => { setLink(""); setFound(null); setError(""); onClose(); };
  const check = async () => {
    setBusy(true); setError(""); setFound(null);
    try { setFound((await api.post("/drive/folder/check", { link })).data); }
    catch (e) { setError(errorMessage(e, "No se pudo revisar el enlace")); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-lg" data-testid="drive-link-dialog">
        <DialogHeader>
          <DialogTitle>Cambiar carpeta</DialogTitle>
          <DialogDescription>Pega el enlace de la carpeta de Google Drive (compartida como «Cualquier persona con el enlace»).</DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <input value={link} onChange={(e) => { setLink(e.target.value); setFound(null); }} placeholder="https://drive.google.com/drive/folders/…"
            className="h-10 flex-1 rounded-xl border border-[#d7e0ec] px-3 text-sm outline-none focus:border-[#0f5ef7]" data-testid="drive-link-input" />
          <button type="button" onClick={check} disabled={busy || !link.trim()} className="tr-btn-light px-4 py-2 text-sm" data-testid="drive-link-check">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Revisar"}
          </button>
        </div>
        {error && <p className="text-sm font-semibold text-[#b42318]" data-testid="drive-link-error">{error}</p>}
        {found && <p className="flex items-center gap-2 rounded-xl bg-[#f2f7ff] px-3 py-2 text-sm font-semibold" data-testid="drive-link-found"><FolderOpen className="h-4 w-4 text-[#0f5ef7]" />{found.name}</p>}
        <DialogFooter className="gap-2">
          <button type="button" onClick={close} className="tr-btn-light px-4 py-2 text-sm" data-testid="drive-link-cancel">Cancelar</button>
          <button type="button" disabled={!found} onClick={() => { onPick(found); close(); }} className="tr-btn-primary px-4 py-2 text-sm disabled:opacity-50" data-testid="drive-link-use">Usar esta carpeta</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
